module.exports = __webpack_public_path__ + "static/media/3004.860640cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/3004.png
// module id = 796
// module chunks = 5